/* EKNO product gallery, deferred media (video / 3D / AR), sticky add-to-cart, share, truncate. */
(function () {
  'use strict';
  const EKNO = window.EKNO;

  /* ---------------------------------------------------------- Gallery */
  class EknoProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gallery__track');
      this.slides = Array.from(this.querySelectorAll('.gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-current]');
      this.dialog = this.querySelector('[data-gallery-dialog]');
      this.index = 0;
      if (!this.track) return;
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.galleryThumb))));
      this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
      this.next?.addEventListener('click', () => this.goTo(this.index + 1));
      this.track.addEventListener('scroll', EKNO.utils.debounce(() => this.syncFromScroll(), 60), { passive: true });
      this.track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') this.goTo(this.index + 1); if (e.key === 'ArrowLeft') this.goTo(this.index - 1); });
      this.querySelectorAll('[data-gallery-zoom], .gallery__img').forEach((el) => el.addEventListener('click', (e) => {
        if (this.dataset.zoom !== 'true') return;
        const slide = e.target.closest('.gallery__slide'); if (!slide || slide.dataset.mediaType !== 'image') return;
        this.openZoom(Number(slide.dataset.index));
      }));
      this.dialog?.addEventListener('click', (e) => { if (e.target === this.dialog || e.target.closest('[data-modal-close]')) this.dialog.close(); });
      this.dialog?.addEventListener('close', () => EKNO.utils.lockScroll(false));
      // Variant → media
      const section = this.closest('[data-section-id]');
      section?.addEventListener('ekno:variant:change', (e) => {
        const media = e.detail.variant?.featured_media; if (!media || e.detail.initial) return;
        const i = this.slides.findIndex((s) => Number(s.dataset.mediaId) === media.id);
        if (i > -1) this.goTo(i);
      });
      // Start at variant media if present
      const initial = this.slides.findIndex((s) => s.hasAttribute('data-variant-media'));
      if (initial > 0) this.goTo(initial, true);
      this.update();
    }
    goTo(i, instant) {
      if (!this.slides.length) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      const slide = this.slides[i];
      const rtl = document.documentElement.dir === 'rtl';
      const isGrid = this.classList.contains('gallery--grid') && window.matchMedia('(min-width: 990px)').matches;
      if (isGrid) { slide.scrollIntoView({ behavior: instant || EKNO.utils.reducedMotion() ? 'auto' : 'smooth', block: 'center' }); }
      else { this.track.scrollTo({ left: (rtl ? -1 : 1) * slide.offsetLeft, behavior: instant || EKNO.utils.reducedMotion() ? 'auto' : 'smooth' }); }
      this.index = i; this.update();
    }
    syncFromScroll() {
      const w = this.track.clientWidth; if (!w) return;
      const i = Math.round(Math.abs(this.track.scrollLeft) / w);
      if (i !== this.index) { this.index = Math.max(0, Math.min(this.slides.length - 1, i)); this.update(); }
    }
    update() {
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
      this.thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === this.index); t.setAttribute('aria-selected', i === this.index ? 'true' : 'false'); if (i === this.index) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      if (this.counter) this.counter.textContent = this.index + 1;
      // Pause videos on inactive slides
      this.slides.forEach((s, i) => { if (i !== this.index) s.querySelectorAll('video').forEach((v) => v.pause()); });
    }
    openZoom(i) {
      if (!this.dialog) return;
      this.dialog.showModal(); EKNO.utils.lockScroll(true);
      const img = this.dialog.querySelector(`[data-dialog-index="${i}"]`);
      img?.scrollIntoView({ block: 'start' });
    }
  }
  customElements.define('ekno-product-gallery', EknoProductGallery);

  /* --------------------------------------------------- Deferred media */
  class EknoDeferredMedia extends HTMLElement {
    connectedCallback() {
      this.querySelector('.deferred-media__play')?.addEventListener('click', () => this.load());
    }
    load() {
      if (this.classList.contains('is-loaded')) return;
      const tpl = this.querySelector('template'); if (!tpl) return;
      const node = tpl.content.cloneNode(true);
      this.appendChild(node); this.classList.add('is-loaded');
      const video = this.querySelector('video'); if (video) { video.play?.().catch(() => {}); video.focus?.(); }
      if (this.hasAttribute('data-model')) loadModelViewer(this);
    }
  }
  customElements.define('ekno-deferred-media', EknoDeferredMedia);

  function loadModelViewer(host) {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {
      host.querySelectorAll('model-viewer').forEach((mv) => { try { new window.Shopify.ModelViewerUI(mv); } catch (e) {} });
    } }]);
  }

  /* --------------------------------------------------------- AR / XR */
  const initXR = () => {
    const btn = document.querySelector('[data-shopify-xr]'); const json = document.querySelector('[data-model-json]');
    if (!btn || !json || !window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: () => {
      const setup = () => { try { window.ShopifyXR.addModels(JSON.parse(json.textContent)); window.ShopifyXR.setupXRElements(); } catch (e) {} };
      if (window.ShopifyXR) setup(); else document.addEventListener('shopify_xr_initialized', setup);
    } }]);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initXR); else initXR();

  /* -------------------------------------------------- Sticky add to cart */
  class EknoStickyAtc extends HTMLElement {
    connectedCallback() {
      const section = document.querySelector(`[data-section-id="${this.dataset.for}"]`);
      const anchor = section?.querySelector('[data-add-to-cart]');
      const btn = this.querySelector('[data-sticky-add]');
      if (!anchor || !btn) return;
      const io = new IntersectionObserver((entries) => { const on = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0; this.classList.toggle('is-visible', on); this.setAttribute('aria-hidden', on ? 'false' : 'true'); }, { threshold: 0 });
      io.observe(anchor);
      btn.addEventListener('click', () => { const form = section.querySelector('form[data-product-form]'); if (form) form.requestSubmit ? form.requestSubmit() : anchor.click(); });
    }
  }
  customElements.define('ekno-sticky-atc', EknoStickyAtc);

  /* ------------------------------------------------------------ Share */
  class EknoShare extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[data-share-native]'); const copied = this.querySelector('[data-share-copied]');
      btn?.addEventListener('click', async () => {
        const data = { title: this.dataset.title, url: this.dataset.url };
        if (navigator.share) { try { await navigator.share(data); } catch (e) {} return; }
        try { await navigator.clipboard.writeText(data.url); copied.hidden = false; setTimeout(() => { copied.hidden = true; }, 2500); } catch (e) { window.prompt('URL', data.url); }
      });
    }
  }
  customElements.define('ekno-share', EknoShare);

  /* --------------------------------------------------------- Truncate */
  class EknoTruncate extends HTMLElement {
    connectedCallback() {
      this.style.setProperty('--lines', this.dataset.lines || 6);
      const content = this.querySelector('.truncate__content'); const toggle = this.querySelector('.truncate__toggle');
      if (!content || !toggle) return;
      const check = () => { const overflow = content.scrollHeight > content.clientHeight + 4; toggle.hidden = !overflow && !this.classList.contains('is-open'); };
      toggle.addEventListener('click', () => { const open = this.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open); toggle.querySelector('[data-more]').hidden = open; toggle.querySelector('[data-less]').hidden = !open; });
      check(); window.addEventListener('resize', EKNO.utils.debounce(check, 200));
    }
  }
  customElements.define('ekno-truncate', EknoTruncate);
})();
